export default {
  getOrdersList: 'GET_ORDERS_LIST',
  getOrdersListSuccess: 'GET_ORDERS_LIST_SUCCESS',
  getOrdersListFailed: 'GET_ORDERS_LIST_FAILED',
  resetToInitialState: 'ORDERS_LIST_RESET_TO_INITIAL_STATE'
};
